module.exports = __webpack_public_path__ + "media/recipes/70-d7871ca7.png";